import React from 'react';
import Icon from '../../../components/AppIcon';

const LanguageToggle = ({ currentLanguage, onLanguageChange }) => {
  return (
    <div className="absolute top-6 right-6">
      <button
        onClick={onLanguageChange}
        className="flex items-center gap-2 px-4 py-2 rounded-lg bg-card border border-border hover:bg-muted transition-colors duration-200"
      >
        <Icon name="Globe" size={18} />
        <span className="text-sm font-medium text-foreground">
          {currentLanguage}
        </span>
      </button>
    </div>
  );
};

export default LanguageToggle;